import uploadssettingsheaderbannerimagedarkbannerPng from "$lib/data/generated/uploads/settings/Header/bannerImageDark/banner.png";
import uploadssettingsheaderbannerimagelightbannerLightPng from "$lib/data/generated/uploads/settings/Header/bannerImageLight/banner-light.png";

export const uploads = {
  "uploads/settings/Header/bannerImageDark/banner.png": uploadssettingsheaderbannerimagedarkbannerPng,
  "uploads/settings/Header/bannerImageLight/banner-light.png": uploadssettingsheaderbannerimagelightbannerLightPng
};